// import React from 'react'

// const PaymentsFromQb = () => {
//   return (
//     <div>PaymentsFromQb</div>
//   )
// }

// export default PaymentsFromQb

import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  NewTableAdv,
  PageHeader,
  PageTitle,
  StatusTags,
} from "../../../components";
import qbLoading from "../../../assets/qbLoading.svg";
import cloud_alert from "../../../assets/cloud_alert.svg";
import cloud_done from "../../../assets/cloud_done.svg";
import { dateFormator, formatNumber, mapTableRows } from "../../../utils";
import QbDocument from "../../../components/Module/Invoices/InvoiceModals/QbDocument";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { qbApiStart } from "../../../redux/slices/quickBooks/quickBooksSlice";
import { usePagination } from "../../../hooks";

const PaymentsFromQb = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { payments, loading } = useSelector((state) => state.quickBooks);
  console.log("payments import  from qb in component", payments);
  const [uploadQb, setUploadQb] = useState(false);
  const tableData = [
    {
      client: "Entrans Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "Entrans Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "VDart Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "VDart Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
  ];
  //design
  // const columns = [
  //   {
  //     key: "client",
  //     label: "Client",
  //     render: (row) => (
  //       <div className="cursor-pointer flex gap-2 items-center">
  //         <Avatar
  //           src={true ? cloud_done : cloud_alert}
  //           alt=""
  //           outline
  //           className="border-none"
  //           size="xs-sm"
  //         />
  //         {/* <Button type="icon" icon={false ? "cloud_alert": "cloud_done"} variant="text" color="black" /> */}
  //         {row.client}
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "invoiceNumber",
  //     label: "Invoice Number",
  //   },
  //   {
  //     key: "paymentDate",
  //     label: "Payment Date",
  //     render: (row) => dateFormator(row.paymentDate, "month-day-year"),
  //   },
  //   {
  //     key: "referenceNumber",
  //     label: "Reference Number",
  //   },
  //   {
  //     key: "receivedAmount",
  //     label: "Received Amount",
  //     render: (row) => <div>{formatNumber(row.receivedAmount)}</div>,
  //   },
  //   // {
  //   //   key: "Actions",
  //   //   label: "Actions",
  //   //   render: (row) => (
  //   // <div className="cursor-pointer">
  //   //   <Avatar
  //   //     src={qbLoading}
  //   //     alt=""
  //   //     outline
  //   //     className="border-none"
  //   //     size="xs"
  //   //   />
  //   // </div>
  //   //   ),
  //   // },
  // ];
  //for now
  const columns = [
    {
      key: "clientName",
      label: "client Name",
      sortable: false,
    },
    {
      key: "businessUnit",
      label: "Business Unit",
      sortable: false,
    },
    {
      key: "referanceNumber",
      label: "Referance Number",
      sortable: false,
    },

    {
      key: "paymentDate",
      label: "payment Date",
      sortable: false,
    },
    {
      key: "paymentMethod",
      label: "payment Method",
      sortable: false,
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      sortable: false,
    },
    {
      key: "creditAmount",
      label: "Credit Amount",
      sortable: false,
    },
    {
      key: "syncstatus",
      label: "Sync Status",
      sortable: false,
    },
  ];

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(
      //   getClientsStart({
      //     page: newPage,
      //     limit: newLimit,
      //     filter: {},
      //     sort: { uiid: -1 },
      //     // sort: { uiid: 1 },
      //     ret: "uiid businessName generalInfo email contact placements jobCode recordStatus",
      //     ref: "PlacementWithEmp",
      //     incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
      //   })
      // );
    }
  );

  useEffect(() => {
    const fetchPayments = async () => {
      dispatch(
        qbApiStart({
          method: "GET",
          entity: "payments",
          params: {
            //working
            // lim: limit * page,
            // pg:1,
            lim: 1000,
          },
          // body: {
          //
          // },
        })
      );
    };
    fetchPayments();
  }, []);
  const mapPaymentData = (payments = []) =>
    payments.map((item) => {
      const line = item?.Line?.[0] || {};
      const metaList = line?.LineEx?.any || [];

      const referenceNumber =
        metaList.find((m) => m?.value?.Name === "txnReferenceNumber")?.value
          ?.Value || "-";

      return {
        clientName: item?.CustomerRef?.name || "-",
        businessUnit: "-",
        referanceNumber: referenceNumber,
        paymentDate: item?.TxnDate || "-",
        paymentMethod: "-", // not available in payload
        receivedAmount: item?.TotalAmt || 0,
        creditAmount: item?.UnappliedAmt || 0,
        syncstatus: item?.SyncToken ? "Synced" : "Unsynced",
      };
    });

  const mappedData = mapPaymentData(payments);
  console.log("mappedData for payments", mappedData);
  const mappedRows = mapTableRows(mappedData, columns);

  return (
    <div className="py-8 px-3">
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"QuickBooks - Payments"} tag="h6" />
            </div>
          }
          RightSection={
            <>
              <div className="flex border border-primary-600 gap-2 items-center px-2 rounded-md py-1 cursor-pointer">
                <Avatar
                  src={qbLoading}
                  alt=""
                  outline
                  className="border-none"
                  size="xs"
                />
                <p className="sub-category-meadium font-medium text-primary">
                  Tek Tree LLC
                </p>
              </div>
              <Button
                title="Back"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => window.history.back()}
              />
            </>
          }
        />
      </div>
      <div className="mb-3">
        <PageHeader
          Section={
            <div className="flex">
              <FormFieldSet
                type="search"
                placeholder="invoice No ,Client ,Employee"
                noTitle
              />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Import / Updates"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => setUploadQb(true)}
              />
            </>
          }
        />
      </div>
      <div>
        <NewTableAdv
          columns={columns}
          rows={mappedRows}
          serverPagination={true}
          totalCount={1000} //for testing
          // page={page}
          limit={1000}
          // hideToolBar
          showCheckbox
        />
      </div>
      <div>
        <QbDocument isOpen={uploadQb} onClose={() => setUploadQb(false)} />
      </div>
    </div>
  );
};

export default PaymentsFromQb;
